import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import moment from "moment";
import { isEmpty } from "lodash";

import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "../MyAccount/MyAccountFilter";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const ReportByPlayer = () => {
  const params = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();

  const previousDate = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    eventType: "all",
    filterByDay: "",
    keyword: "",
    created_by: params?.id || user?._id,
    userType: params?.user_type || user?.userType,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState([]);
  const [obj, setObj] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.reportPlayer,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      const rows = response_users.results?.data || [];
      setData(rows);

      const commission = rows.reduce(
        (a, v) => a + Number(v?.commission || 0),
        0,
      );
      const downlinePnl = rows.reduce((a, v) => a + Number(v?.amount || 0), 0);
      setObj({ commission, downlinePnl });
    }
  };

  useEffect(() => {
    getData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, filter.limit, filter.eventType, filter.created_by, filter.userType]);

  useEffect(() => {
    const createdBy = params?.id || user?._id;
    const userType = params?.user_type || user?.userType;
    setFilter((prev) =>
      prev.created_by === createdBy && prev.userType === userType
        ? prev
        : { ...prev, page: 1, created_by: createdBy, userType },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id, params?.user_type]);

  const applyPreset = (preset) => {
    const nextFilter = { ...filter, filterByDay: preset };
    setFilter(nextFilter);
    getData(nextFilter);
  };

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  const handleKeywordChange = (e) =>
    setFilter((prev) => ({ ...prev, keyword: e.target.value }));

  // old's `search(item)` drilled into that user's own downline by refetching
  // with created_by/userType of the clicked row - here that's just a route
  // change, and the params-effect above refetches automatically
  const drillInto = (item) => {
    const nextFilter = {
      ...filter,
      page: 1,
      created_by: item?._id,
      userType: item?.userType,
    };
    setFilter(nextFilter);
  };

  const plSpan = (value) =>
    value ? (
      Math.sign(value) === -1 ? (
        <span className="loss-text">
          ({toFixedWithoutRounding(Math.abs(value))})
        </span>
      ) : (
        <span className="profit-text">
          {toFixedWithoutRounding(Math.abs(value))}
        </span>
      )
    ) : (
      "-"
    );

  const totalRecords = data?.length || 0;

  return (
    <app-pl-player _nghost-serverapp-c118 className="ng-star-inserted">
      <div _ngcontent-serverapp-c118 className="main_wrap">
        <div _ngcontent-serverapp-c118 className="box">
          <h2 _ngcontent-serverapp-c118>Profit/Loss Report by Player</h2>
        </div>
        <ul _ngcontent-serverapp-c118 className="report-tab-wrap">
          <li
            id="reportType_exchange"
            data-reporttabtype={0}
            className="report-tab select"
          >
            <a>Exchange</a>
          </li>
        </ul>
        <div _ngcontent-serverapp-c118 className="function-wrap">
          <ul _ngcontent-serverapp-c118 className="input-list flowroot">
            <li _ngcontent-serverapp-c118 />
            <li _ngcontent-serverapp-c118>
              <label _ngcontent-serverapp-c118>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />

            <li _ngcontent-serverapp-c131>
              <label _ngcontent-serverapp-c131>Sports:</label>
            </li>
            <li _ngcontent-serverapp-c131>
              <select
                name="betStatus"
                id="betStatus"
                className="ng-untouched ng-pristine ng-valid"
                value={filter?.eventType}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, eventType: e.target.value, page: 1 }))
                }
              >
                <option className="ng-star-inserted" value="all">
                  All
                </option>
                <option className="ng-star-inserted" value="4">
                  Cricket
                </option>
                <option className="ng-star-inserted" value="1">
                  Soccer
                </option>{" "}
                <option className="ng-star-inserted" value="2">
                  Tennis
                </option>{" "}
                <option className="ng-star-inserted" value="-1">
                  Casino
                </option>
              </select>
            </li>
          </ul>
          <ul _ngcontent-serverapp-c118 className="input-list flowroot">
            <li _ngcontent-serverapp-c118>
              <a
                id="today"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li _ngcontent-serverapp-c118>
              <a
                id="yesterday"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li _ngcontent-serverapp-c118>
              <a
                id="getPL"
                className="btn-send"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>
        <div _ngcontent-serverapp-c118 id="noReportMessage" />
        <div _ngcontent-serverapp-c118 id="userTreeDiv" className="total_all">
          <input
            type="text"
            appinputrestriction="noSpecialChars3"
            placeholder="Search by UserName"
            value={filter.keyword}
            onChange={handleKeywordChange}
          />
          <span _ngcontent-serverapp-c118 className="spacer" />
          <span>
            <label _ngcontent-serverapp-c118>Last:</label>
            <select
              name="limit"
              id="limit"
              className="ng-star-inserted"
              value={filter.limit}
              onChange={handleLimitChange}
            >
              <option value={100}>100 Txn</option>
              <option value={50}>50 Txn</option>
              <option value={25}>25 Txn</option>
              <option value={10}>10 Txn</option>
            </select>
          </span>
          <span
            _ngcontent-serverapp-c118
            className="total-users"
            style={{ fontWeight: "600" }}
          >
            Total Records: {totalRecords}{" "}
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="report-player"
          />
        </div>
        <div
          _ngcontent-serverapp-c87
          id="reportDiv"
          className="over-wrap"
          style={{ maxHeight: "calc(100% - 32px - 93px - 55px)" }}
        >
          <div _ngcontent-serverapp-c87 className="table-responsive data-table">
            <table
              ref={tableRef}
              _ngcontent-serverapp-c87
              id="table_DL"
              className="table01 table-pt"
            >
              <tbody _ngcontent-serverapp-c87>
                <tr id="table_DL">
                  <th
                    id="header_userName"
                    width="15%"
                    className="align-L sort_asc"
                  >
                    UID
                  </th>
                  <th id="header_userName" width="15%" className="align-L">
                     <span className="Bdlevel lv_8 p premium" /> Parent
                  </th>
                  <th width="20%" className="sort_asc">
                    Player P/L{" "}
                  </th>
                  <th id="header_tax_agent_2" width="10%" className="sort_asc">
                    Agent Comm.
                  </th>
                </tr>
              </tbody>
              <tbody id="content">
                {!isEmpty(data) ? (
                  data.map((item, index) => (
                    <tr id="table_DL" key={item?._id || index}>
                      <td className="align-L">
                        <a
                          id="_userName"
                          className="ico_account"
                          style={{ cursor: "pointer" }}
                          onClick={() => drillInto(item)}
                        >
                          <span className="Bdlevel lv_9 p premium" />
                          {item?.username}{" "}
                        </a>
                      </td>
                      <td className="align-L">
                        <span><span className="Bdlevel lv_8 p premium" />{item?.parent || "-"} </span>
                      </td>
                      <td id="_profitLoss">
                        <div>{plSpan(item?.amount)}</div>
                      </td>
                      <td id="_tax2">
                        <div>
                          <span>
                            {" "}
                            {toFixedWithoutRounding(item?.commission || 0)}{" "}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>You have no bets in this time period.</td>
                  </tr>
                )}

                {!isEmpty(data) && (
                  <tr className="total">
                    <td className="align-L">Total</td>
                    <td className="align-L" />
                    <td>
                      <div>{plSpan(obj?.downlinePnl)}</div>
                    </td>
                    <td id="_totalComm">
                      <span>
                        {" "}
                        {toFixedWithoutRounding(obj?.commission || 0)}{" "}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </app-pl-player>
  );
};

export default ReportByPlayer;
